

/// <reference path="FileItem.ts" />

// Generated class BankTransferBundleFile_ManagedObject

class BankTransferBundleFile_ManagedObject extends FileItem
{

    // Property: beginDate
    set beginDate(value:Date) {
        this.setValueForKey(value, 'beginDate');
    }
    get beginDate():Date {
        return this.valueForKey('beginDate');
    }
    set beginDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'beginDate');
    }
    get beginDatePrimitiveValue():Date {
        return this.primitiveValueForKey('beginDate');
    }

    // Property: concept
    set concept(value:string) {
        this.setValueForKey(value, 'concept');
    }
    get concept():string {
        return this.valueForKey('concept');
    }
    set conceptPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'concept');
    }
    get conceptPrimitiveValue():string {
        return this.primitiveValueForKey('concept');
    }

    // Property: endDate
    set endDate(value:Date) {
        this.setValueForKey(value, 'endDate');
    }
    get endDate():Date {
        return this.valueForKey('endDate');
    }
    set endDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'endDate');
    }
    get endDatePrimitiveValue():Date {
        return this.primitiveValueForKey('endDate');
    }

    // Property: fileType
    set fileType(value:number) {
        this.setValueForKey(value, 'fileType');
    }
    get fileType():number {
        return this.valueForKey('fileType');
    }
    set fileTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'fileType');
    }
    get fileTypePrimitiveValue():number {
        return this.primitiveValueForKey('fileType');
    }

    // Property: formatType
    set formatType(value:number) {
        this.setValueForKey(value, 'formatType');
    }
    get formatType():number {
        return this.valueForKey('formatType');
    }
    set formatTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'formatType');
    }
    get formatTypePrimitiveValue():number {
        return this.primitiveValueForKey('formatType');
    }

    // Property: reference
    set reference(value:string) {
        this.setValueForKey(value, 'reference');
    }
    get reference():string {
        return this.valueForKey('reference');
    }
    set referencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'reference');
    }
    get referencePrimitiveValue():string {
        return this.primitiveValueForKey('reference');
    }

    // Property: referenceDateString
    set referenceDateString(value:string) {
        this.setValueForKey(value, 'referenceDateString');
    }
    get referenceDateString():string {
        return this.valueForKey('referenceDateString');
    }
    set referenceDateStringPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'referenceDateString');
    }
    get referenceDateStringPrimitiveValue():string {
        return this.primitiveValueForKey('referenceDateString');
    }

    // Property: textContent
    set textContent(value:string) {
        this.setValueForKey(value, 'textContent');
    }
    get textContent():string {
        return this.valueForKey('textContent');
    }
    set textContentPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'textContent');
    }
    get textContentPrimitiveValue():string {
        return this.primitiveValueForKey('textContent');
    }

    // Property: totalAmount
    set totalAmount(value:number) {
        this.setValueForKey(value, 'totalAmount');
    }
    get totalAmount():number {
        return this.valueForKey('totalAmount');
    }
    set totalAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'totalAmount');
    }
    get totalAmountPrimitiveValue():number {
        return this.primitiveValueForKey('totalAmount');
    }

    // Relationship: installments
    protected _installments:MIOManagedObjectSet = null;
    get installments():MIOManagedObjectSet {
        return this.valueForKey('installments');
    }
    addInstallmentsObject(value:LegalEntityPaymentInstallment) {
        this._addObjectForKey(value, 'installments');
    }
    removeInstallmentsObject(value:LegalEntityPaymentInstallment) {
        this._removeObjectForKey(value, 'installments');
    }
    // Relationship: journalEntry
    set journalEntry(value:AccountingJournalEntry) {
        this.setValueForKey(value, 'journalEntry');
    }
    get journalEntry():AccountingJournalEntry {
        return this.valueForKey('journalEntry') as AccountingJournalEntry;
    }
}
